import { useEffect, useState } from "react";

import { Organization } from "@/types/organization";
import { TaxExemption } from "@/types/tax-exemption";

export function useSubscribeEligibility(
  organization: Organization | null,
  taxExemption: TaxExemption | null,
) {
  const [isSubscribeDisabled, setIsSubscribeDisabled] = useState(true);
  const [isPendingTaxExemption, setIsPendingTaxExemption] = useState(false);

  useEffect(() => {
    if (organization === null) {
      setIsSubscribeDisabled(true);
      return;
    }

    if (
      taxExemption &&
      (taxExemption.status !== "approved" ||
        organization.customerId === "UNASSIGNED")
    ) {
      setIsPendingTaxExemption(true);
      setIsSubscribeDisabled(true);
      return;
    }

    setIsPendingTaxExemption(false);
    setIsSubscribeDisabled(false);
  }, [organization, taxExemption]);

  return {
    isSubscribeDisabled,
    isPendingTaxExemption,
  };
}
